(function () {
  // Add custom code below this line

  //
  //
  //
  //

  document.addEventListener("DOMContentLoaded", function () {

    console.log('acccess');
    const articleContent = document.querySelector(
      ".article-template__content-rte"
    );
    const tocContainer = document.querySelector(".table-of-contents");
    const placeholderCont = document.querySelector(".placeholderCont");

    console.log(articleContent);
    console.log(tocContainer);
    console.log(placeholderCont);

    if (!articleContent || !tocContainer) return;

    const headings = Array.from(articleContent.querySelectorAll("h2"));
    if (headings.length === 0) {
      tocContainer.style.display = "none";
      placeholderCont.style.display = "none";
      return;
    }

    function generateTOC() {
      tocContainer.style.display = "block";
      placeholderCont.style.display = "block";
      tocContainer.innerHTML = "";

      if (window.innerWidth < 1199) {
        tocContainer.style.width = "100%";
        placeholderCont.style.width = "100%";
        const select = document.createElement("select");
        select.className = "article-toc-dropdown";
        select.onchange = function () {
          if (this.value) {
            location.href = this.value;
          }
        };

        const defaultOption = document.createElement("option");
        defaultOption.textContent = "Jump to section...";
        defaultOption.disabled = true;
        defaultOption.selected = true;
        select.appendChild(defaultOption);

        headings.forEach((heading, index) => {
          if (!heading.id) heading.id = "heading-" + index;

          const option = document.createElement("option");
          option.value = "#" + heading.id;
          option.textContent = heading.textContent;

          select.appendChild(option);
        });

        tocContainer.appendChild(select);
      } else {
        tocContainer.style.width = "25%";
        placeholderCont.style.width = "5%";

        const ul = document.createElement("ul");
        ul.className = "article-toc";

        headings.forEach((heading, index) => {
          if (!heading.id) heading.id = "heading-" + index;

          const li = document.createElement("li");
          li.className = heading.tagName.toLowerCase();

          const link = document.createElement("a");
          link.href = "#" + heading.id;
          link.textContent = heading.textContent;
          link.dataset.headingId = heading.id;

          li.appendChild(link);
          ul.appendChild(li);
        });

        tocContainer.appendChild(ul);
      }
    }

    generateTOC();
    window.addEventListener("resize", generateTOC);

    // Scroll Highlighting
    const tocLinks = tocContainer.querySelectorAll("a");
    const observerOptions = {
      root: null,
      rootMargin: "0px 0px -50% 0px",
      threshold: 0.1,
    };

    let activeHeading = null;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const targetId = entry.target.id;
        if (entry.isIntersecting) {
          activeHeading = targetId;

          // Remove active class from all links
          tocLinks.forEach((link) =>
            link.parentElement.classList.remove("active")
          );

          // Add active class to the current one
          const activeLink = tocContainer.querySelector(
            `[href="#${targetId}"]`
          );
          if (activeLink) {
            activeLink.parentElement.classList.add("active");
          }
        }
      });
    }, observerOptions);

    headings.forEach((heading) => observer.observe(heading));
  });

  //
  //
  //
    console.log('here')
  // Progress bar




  // Recalculate on load & resize

})();


// 
  let progressBar = document.getElementById("article-progress");
  let header = document.querySelector(".header");
  let newsletter = document.querySelector(".newsletter");
  let footer = document.querySelector(".shopify-section-group-footer-group");

  let adjustedHeight = 0; // Store adjusted height globally


if (urlContainsBlogsPost()) {  
  calculateAdjustedHeight();
  window.addEventListener("resize", () => {
    clearTimeout(window.resizedFinished);
    window.resizedFinished = setTimeout(calculateAdjustedHeight, 200);
  });

  document.addEventListener("scroll", updateProgress);

}


  function calculateAdjustedHeight() {
    let headerHeight = header ? header.offsetHeight : 0;
    let newsletterHeight = newsletter ? newsletter.offsetHeight : 0;
    let footerHeight = footer ? footer.offsetHeight : 0;

    let scrollHeight =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    adjustedHeight =
      scrollHeight - (newsletterHeight + footerHeight) + headerHeight;
  }



  function updateProgress() {
    let scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    let progress = (scrollTop / adjustedHeight) * 100;
    progressBar.style.width = Math.min(progress, 100) + "%"; // Prevent exceeding 100%
  }



function urlContainsBlogsPost() {
  return window.location.pathname.includes('/blogs/post/');
}